import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconCarSide: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
        xmlns: 'http://www.w3.org/2000/svg',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M20 10H19.5L15.8 5.4C15.6 5.1 15.3 5 15 5H5C4.6 5 4.2 5.2 4.1 5.6L2.1 10.6C2 10.7 2 10.8 2 11V16C2 17.1 2.9 18 4 18H4.2C4.6 19.2 5.7 20 7 20C8.3 20 9.4 19.2 9.8 18H14.2C14.6 19.2 15.7 20 17 20C18.3 20 19.4 19.2 19.8 18H20C21.1 18 22 17.1 22 16V12C22 10.9 21.1 10 20 10ZM16.9 10H12V7H14.5L16.9 10ZM5.7 7H10V10H4.5L5.7 7ZM7 18C6.4 18 6 17.6 6 17C6 16.4 6.4 16 7 16C7.6 16 8 16.4 8 17C8 17.6 7.6 18 7 18ZM17 18C16.4 18 16 17.6 16 17C16 16.4 16.4 16 17 16C17.6 16 18 16.4 18 17C18 17.6 17.6 18 17 18ZM20 16H19.8C19.4 14.8 18.3 14 17 14C15.7 14 14.6 14.8 14.2 16H9.8C9.4 14.8 8.3 14 7 14C5.7 14 4.6 14.8 4.2 16H4V12H19H20V16Z',
    })
  )
}
